"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.endpoint = void 0;
const betagreen_1 = __importDefault(require("./api/betagreen"));
const beta_1 = __importDefault(require("./api/beta"));
const pro_1 = __importDefault(require("./api/pro"));
const prodgreen_1 = __importDefault(require("./api/prodgreen"));
let config;
let platform = '';
if (typeof location !== 'undefined' || typeof ((_a = process === null || process === void 0 ? void 0 : process.env) === null || _a === void 0 ? void 0 : _a.NEXT_PUBLIC_API_ENV) !== 'undefined') {
    config = {
        API_ENV: process.env.NEXT_PUBLIC_API_ENV,
        dev: {
            host: process.env.NEXT_PUBLIC_HOST,
            host_api_v1: process.env.NEXT_PUBLIC_HOST_API_V1,
            host_newapi: process.env.NEXT_PUBLIC_HOST_NEWAPI,
            get_short_link_url: process.env.NEXT_PUBLIC_HOST_SHORT
        }
    };
    platform = 'web';
}
else {
    const RNConfig = require('react-native-config');
    config = typeof RNConfig.Config !== 'undefined' ? RNConfig.Config : {};
    platform = 'app';
}
const getApi = (env, options) => {
    let api;
    switch (env) {
        case 'local':
        case 'dev':
            api = Object.assign(Object.assign(Object.assign({}, beta_1.default), { host: 'https://newapi.dev.dipbit.xyz/', host_api_v1: 'https://api.dev.dipbit.xyz/', host_newapi: 'https://api.dev.dipbit.xyz/', traceHost: 'https://api.dipbit.xyz:9412' }), options === null || options === void 0 ? void 0 : options.dev);
            break;
        case 'beta':
            api = beta_1.default;
            if (platform === 'web') {
                api = Object.assign(Object.assign({}, api), { host: 'https://webbeta.kikitrade.com/api/', host_newapi: 'https://webbeta.kikitrade.com/newapi/', host_api_v1: 'https://webbeta.kikitrade.com/newapi/' });
            }
            break;
        case 'beta1': {
            api = beta_1.default;
            if (platform === 'web') {
                api = Object.assign(Object.assign({}, api), { host: 'https://webbeta1.kikitrade.com/api/', host_newapi: 'https://webbeta1.kikitrade.com/newapi/', host_api_v1: 'https://webbeta1.kikitrade.com/newapi/' });
            }
            break;
        }
        case 'betaGreen':
            api = betagreen_1.default;
            break;
        case 'pre1': {
            api = prodgreen_1.default;
            if (platform === 'web') {
                api = Object.assign(Object.assign({}, api), { host: 'https://webprod1.kikitrade.com/pro_api/', host_newapi: 'https://webprod1.kikitrade.com/pro_newapi/', host_api_v1: 'https://webprod1.kikitrade.com/pro_newapi/' });
            }
            break;
        }
        case 'pre': {
            api = prodgreen_1.default;
            if (platform === 'web') {
                api = Object.assign(Object.assign({}, api), { host: 'https://webprod.kikitrade.com/pro_api/', host_newapi: 'https://webprod.kikitrade.com/pro_newapi/', host_api_v1: 'https://webprod.kikitrade.com/pro_newapi/' });
            }
            break;
        }
        case 'prodgreen':
            api = prodgreen_1.default;
            break;
        case 'pro':
        case 'prod':
        default:
            api = pro_1.default;
            break;
    }
    return api;
};
const getWebSocket = (env) => {
    let websocket = {
        host: 'ws://wstest.kikitrade.com:8080',
        appCode: 'c022929d0e1f4b0d8eace9cb9934bf0d',
        stage: 'TEST',
    };
    if (['prodgreen', 'prod', 'pre1', 'pre', 'pro'].includes(env)) {
        websocket = {
            host: 'ws://ws.kikitrade.com:8080',
            appCode: 'c022929d0e1f4b0d8eace9cb9934bf0d',
            stage: 'RELEASE',
        };
    }
    return websocket;
};
const env = (config === null || config === void 0 ? void 0 : config.API_ENV) || 'prod';
const api = getApi(env, ['dev', 'local'].includes(env) ? config : null);
const websocket = getWebSocket(env);
exports.endpoint = {
    api,
    websocket,
};
//# sourceMappingURL=endpoint.js.map